import React from 'react'
import { MainPageBlockForm } from '../form/MainPageConfigFormState'

type LoyaltyLevelBlockProps = {
  block: MainPageBlockForm
  onChange: (block: MainPageBlockForm) => void
}

export default function LoyaltyLevelBlock ({
  block,
  onChange
}: LoyaltyLevelBlockProps) {
  return (
    <div>
      <h4>Уровень программы лояльности</h4>
      <p>Блок отображает текущий уровень пользователя в программе лояльности. Дополнительные настройки не требуются.</p>
    </div>
  )
}